module.exports = __webpack_public_path__ + "img/Challengermode.cd062f1a.png";